/** 'YYYY-MM' → 'July 2026'. */
export function monthLabel(month: string): string {
  const [y, m] = month.split('-').map((n) => parseInt(n, 10));
  if (!y || !m) return month;
  return new Date(Date.UTC(y, m - 1, 1)).toLocaleDateString('en-GB', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
